const routes = {
  CATEGORY: (categoryId = '*') => `category/${categoryId}`,
  CATEGORY_PRODUCT: (categoryId= '*', productId= '*') => `category/${categoryId}/product/${productId}`,
  TAG: (tag= '*') => `tag/${tag}`,
  TAG_PRODUCT: (tag = '*', productId= '*') => `tag/${tag}/product/${productId}`,
  MENU: () => ``,
}

export { routes }
